import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=999c0208&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('999c0208')) {
      api.createRecord('999c0208', component.options)
    } else {
      api.reload('999c0208', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=999c0208&", function () {
      api.rerender('999c0208', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/winner/Index.vue"
export default component.exports